import React, { useState } from 'react';
import Loading from '../../../Components/Loading';
import { useLazyPatientDataQuery, User } from '../../../graphql/graphql';

export interface PatientDataContextProviderProps {
	children?: React.ReactChild | React.ReactChild[];
}

export interface PatientDataContextProps {
	patient?: User;
	getOrLoadPatient: (patientId: string) => Promise<User | undefined>;
}

export const PatientDataContext = React.createContext<PatientDataContextProps>({
	patient: undefined,
	getOrLoadPatient: async () => undefined,
});

export const usePatientDataContext: () => PatientDataContextProps = () => {
	return React.useContext<PatientDataContextProps>(PatientDataContext);
};

export function PatientDataContextProvider({
	children,
}: PatientDataContextProviderProps) {
	const [isLoading, setIsLoading] = useState(false);
	const [patient, setPatient] = useState<User | undefined>(undefined);

	const [getPatientData] = useLazyPatientDataQuery();

	const loadPatient = async (patientId: string) => {
		// LOAD PATIENT DATA
		const data = await getPatientData({ id: patientId });
		const user: User | undefined = data?.data?.user || undefined;
		setPatient(user);
		return user;
	};

	const getOrLoadPatient = async (patientId: string) => {
		// IF I HAVE PATIENT AND IS THE SAME ONE I AM LOOKING FOR RETURN PATIENT
		if (patient?.id === patientId) {
			return patient;
		}
		// IF I DO NOT HAVE PATIENT OR I AM LOOKING FOR ANOTHER ONE LOAD IT
		return await loadPatient(patientId);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<PatientDataContext.Provider value={{ patient, getOrLoadPatient }}>
			{children}
		</PatientDataContext.Provider>
	);
}
